import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@communityshare/ui-shared/images/logo.png';
import classNames from 'classnames';
import { useConfig } from '@lore/config';

export default function NavigationLogo() {
  const config = useConfig();

  // Determine environment label and bg color based on host
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const env =
    host === 'localhost' || host === '127.0.0.1' ? { label: 'local', bg: 'bg-cs-yellow-500' }
    : host === 'steward-staging.communityshare.org' ? { label: 'staging', bg: 'bg-cs-orange-500' }
    : host === 'steward-staging-next.communityshare.org' ? { label: 'staging+', bg: 'bg-cs-orange-800' }
    : host === 'steward-next.communityshare.org' ? { label: 'prod+', bg: 'bg-cs-purple-500' }
    : null;

  return (
    <>
    <Link to="/" className="flex justify-center">
      <img className={classNames(
        // 'h-12 w-12',
        'max-h-12 max-w-12',
        'aspect-square',
        config.flags.grayscale && 'grayscale'
      )} src={logo} alt="logo" />
    </Link>
      {env && (
        <div className={classNames(
          env.bg,
          'text-white w-fit p-3 items-center justify-center rounded-lg text-xs h-6 inline-flex'
        )}>
          {env.label}
        </div>
      )}
    </>
  );
}
